import { getDownloadURL, ref, uploadBytes } from 'firebase/storage'
import { storage } from '@/lib/firebase'
import { normalizeInstagramHandle } from '@/lib/localGuestSpots'

const LOCAL_GUEST_SPOT_PROFILE_IMAGES_FOLDER = 'localGuestSpotProfileImages'
const LOCAL_GUEST_SPOT_TATTOO_IMAGES_FOLDER = 'localGuestSpotTattooImages'

function buildSafeFileExtension(file: File): string {
  const extensionFromName = file.name.split('.').pop()?.toLowerCase()
  if (extensionFromName && /^[a-z0-9]+$/.test(extensionFromName)) {
    return extensionFromName
  }

  if (file.type === 'image/webp') return 'webp'
  if (file.type === 'image/png') return 'png'
  return 'jpg'
}

export async function uploadLocalGuestSpotProfileImage(
  profileImageFile: File,
  instagramUsername: string,
): Promise<string> {
  const normalizedUsername = normalizeInstagramHandle(instagramUsername)
  if (!normalizedUsername) {
    throw new Error('Instagram username is required to upload a profile image')
  }

  const fileExtension = buildSafeFileExtension(profileImageFile)
  const storagePath = `${LOCAL_GUEST_SPOT_PROFILE_IMAGES_FOLDER}/${normalizedUsername}_profile_image.${fileExtension}`
  const storageReference = ref(storage, storagePath)

  await uploadBytes(storageReference, profileImageFile, {
    contentType: profileImageFile.type || `image/${fileExtension}`,
  })

  return getDownloadURL(storageReference)
}

export async function uploadLocalGuestSpotTattooImage(
  tattooImageFile: File,
  instagramUsername: string,
  slotIndex: number,
): Promise<string> {
  const normalizedUsername = normalizeInstagramHandle(instagramUsername)
  if (!normalizedUsername) {
    throw new Error('Instagram username is required to upload tattoo images')
  }

  const fileExtension = buildSafeFileExtension(tattooImageFile)
  const storagePath = `${LOCAL_GUEST_SPOT_TATTOO_IMAGES_FOLDER}/${normalizedUsername}_admin_slot${slotIndex + 1}_${Date.now()}.${fileExtension}`
  const storageReference = ref(storage, storagePath)

  await uploadBytes(storageReference, tattooImageFile, {
    contentType: tattooImageFile.type || `image/${fileExtension}`,
  })

  return getDownloadURL(storageReference)
}
